import {NgModule} from '@angular/core';

import {SharedModule} from "../../common/shared.module";
import {TranslocoModule} from "@ngneat/transloco";
import {ShoppingRoutingModule} from "./shopping-routing.module";
import {ShoppingComponent} from "./shopping/shopping.component";
import {ShoppingEntryComponent} from "./shopping-entry/shopping-entry.component";
import {ProductsComponent} from "./products/products.component";
import {CheckoutComponent} from "./checkout/checkout.component";
import {CartNavsComponent} from "./cart-nav/cart-navs.component";
import {OrderCompletedComponent} from "./order-completed/order-completed.component";
import {SubscriberComponent} from "./subscriber/subscriber.component";
import {StartModule} from "..";

@NgModule({
    declarations: [
        ShoppingEntryComponent,
        SubscriberComponent,
        CartNavsComponent,
        CheckoutComponent,
        ProductsComponent,
        OrderCompletedComponent,
        ShoppingComponent
    ],
    imports: [SharedModule, TranslocoModule, ShoppingRoutingModule, StartModule],
    exports: []
})
export class ShoppingModule {
}
